import { render, staticRenderFns } from "./ViewPaymentActions.vue?vue&type=template&id=6878dd3b&scoped=true&lang=pug&"
import script from "./ViewPaymentActions.vue?vue&type=script&lang=js&"
export * from "./ViewPaymentActions.vue?vue&type=script&lang=js&"
import style0 from "./ViewPaymentActions.vue?vue&type=style&index=0&id=6878dd3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6878dd3b",
  null
  
)

export default component.exports